import _orderBy from "lodash/orderBy"
import ShiftsAPIClientHTTP from 'frontcore/presentation/shifts/data/ShiftsAPIService'
import { computed, ComputedRef, reactive } from "vue"
import { defineStore } from 'pinia'
import { PROMISE_STATUS } from 'frontcore/constants'
import { Proxy } from "frontcore/constants/proxy"
import { Shift } from 'frontcore/presentation/shifts/data/types'

interface IShiftsState {
  shifts: Proxy<Shift[]>,
}

interface IShiftsStore {
  state: IShiftsState,
  getShifts: ComputedRef<Shift[]>
  fetch: () => Promise<Shift[]>
  getShiftById: (shiftId: number) => Shift | undefined
}

export const useShiftsStore = defineStore('shifts', (): IShiftsStore => {
  const state = reactive<IShiftsState>({
    shifts: {
      data: [],
      promise: Promise.resolve([]),
      promiseStatus: PROMISE_STATUS.notStarted,
    },
  })

  const fetch = async () => {
    const apiService = new ShiftsAPIClientHTTP()
    if (state.shifts.promiseStatus === PROMISE_STATUS.notStarted) {
      state.shifts.promise = apiService.fetch()
      state.shifts.promiseStatus = PROMISE_STATUS.pending
    }

    try {
      if (state.shifts.data.length === 0) {
        const shifts = await state.shifts.promise
        const orderedShifts = _orderBy(shifts, 'order')
        state.shifts.data = orderedShifts
        state.shifts.promiseStatus = PROMISE_STATUS.complete
      }
    } catch (e) {
      state.shifts.promiseStatus = PROMISE_STATUS.notStarted
    }

    return state.shifts.data
  }

  const getShifts = computed(() => state.shifts.data.filter(shift => shift.enabled))

  const getShiftById = (shiftId: number): Shift | undefined => {
    return getShifts.value.find((shift) => shift.id === shiftId)
  }

  return {
    state,
    getShifts,
    fetch,
    getShiftById,
  }
})
